import { useCallback } from 'react'
import { useTheme } from '@mui/material'
import { ThemeColor } from '@/theme/usePixydocsTheme'
import useThemeMode from './useThemeMode'

export default function useGetThemeColor(): (colorName?: ThemeColor) => string {
  const theme = useTheme()
  const [themeMode] = useThemeMode()

  return useCallback(
    (colorName?: ThemeColor) => {
      // Casting is weird here, but the alternative was a bunch of if statements
      // for logic that never changes.
      const palette = theme.palette as unknown as Record<
        string,
        { dark: string; light: string }
      >
      const themeColor = palette[colorName || '']
      if (!themeColor) return theme.palette.text.secondary
      return themeColor[themeMode === 'dark' ? 'dark' : 'light']
    },
    [theme, themeMode],
  )
}
